<template>
  <div class="sortable-item sortable-item-image width-fit-content">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Imagen <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <img
        :src="block.data.url ? block.data.url : block.data.file"
        :alt="block.data.name"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockImage',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
    }
  },

  computed: {
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    }
  }
}
</script>
